"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stateFromHTML = stateFromHTML;
exports.stateToHTML = stateToHTML;
exports.stateToMarkdown = stateToMarkdown;
Object.defineProperty(exports, "stateFromMarkdown", {
  enumerable: true,
  get: function get() {
    return _draftJsImportMarkdown.stateFromMarkdown;
  }
});

var _react = _interopRequireDefault(require("react"));

var _draftConvert = require("draft-convert");

var _draftJsImportMarkdown = require("draft-js-import-markdown");

var _draftJsExportMarkdown = require("draft-js-export-markdown");

var _lib = require("../../lib");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultDraftJSBlockRenderMap = {
  'header-one': 'h1',
  'header-two': 'h2',
  'header-three': 'h3',
  'header-four': 'h4',
  'header-five': 'h5',
  'header-six': 'h6',
  blockquote: 'blockquote',
  'code-block': 'pre',
  atomic: 'figure',
  'unordered-list-item': 'li',
  'ordered-list-item': 'li',
  unstyled: 'p'
};
var parseOptions = {
  blockStyleFn: function blockStyleFn(block) {
    var data = block.getData();
    var styles = {}; // textAligns

    var textAlign = data.get('textAlign');

    if (textAlign) {
      styles.textAlign = textAlign;
    }

    if ((0, _lib.objHasKeys)(styles)) {
      return {
        style: _objectSpread({}, styles)
      };
    }

    return null;
  }
}; // HTML uses draft-convert npm package
// NOTE: Refer https://github.com/HubSpot/draft-convert

function stateFromHTML(html) {
  return (0, _draftConvert.convertFromHTML)({
    htmlToEntity: function htmlToEntity(nodeName, node, createEntity) {
      if (nodeName === 'a') {
        // link entity
        return createEntity('LINK', 'MUTABLE', {
          url: node.href,
          target: node.target
        });
      }

      return null;
    },
    htmlToBlock: function htmlToBlock(nodeName, node) {
      if (node && node.style) {
        var style = node.style;
        var styles = {}; // textAligns

        var textAlign = style.textAlign;

        if (textAlign) {
          styles = _objectSpread({}, styles, {
            textAlign: textAlign
          });
        }

        if ((0, _lib.objHasKeys)(styles)) {
          return {
            data: _objectSpread({}, styles)
          };
        }
      }

      return null;
    }
  })(html);
}

function stateToHTML(html) {
  return (0, _draftConvert.convertToHTML)({
    styleToHTML: function styleToHTML(style) {
      var styles = {};

      if (style === 'STRIKETHROUGH') {
        styles = _objectSpread({}, styles, {
          textDecoration: 'line-through'
        });
      }

      if (style === 'UNDERLINE') {
        styles = _objectSpread({}, styles, {
          textDecoration: 'underline'
        });
      } // has special styles only render span with inline styles
      // no return indicate original tag


      if ((0, _lib.objHasKeys)(styles)) {
        return _react.default.createElement("span", {
          style: styles
        });
      }
    },
    blockToHTML: function blockToHTML(block) {
      var Tag = defaultDraftJSBlockRenderMap[block.type];
      var props = {};

      if (block) {
        var data = block.data;

        if (data) {
          // styles saved in metadata
          props = {
            style: _objectSpread({}, data)
          };
        }
      }

      if (block.type === 'ordered-list-item') {
        return {
          element: _react.default.createElement(Tag, props),
          nest: _react.default.createElement("ol", null)
        };
      }

      if (block.type === 'unordered-list-item') {
        return {
          element: _react.default.createElement(Tag, props),
          nest: _react.default.createElement("ul", null)
        };
      }

      return _react.default.createElement(Tag, props);
    },
    entityToHTML: function entityToHTML(entity, text) {
      if (entity.type === 'LINK') {
        return _react.default.createElement("a", {
          href: entity.data.url
        }, text);
      }

      return text;
    }
  })(html);
}

function stateToMarkdown(html) {
  return (0, _draftJsExportMarkdown.stateToMarkdown)(html, parseOptions);
}